import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import OverlayImage from './OverlayImage';
import {
  alignmentType,
  responsiveImageType,
  typographyType,
} from '../../propTypes';
import {
  getSliceActiveMenuIndex,
  getSliceAlignment,
  getSliceIsEdgeToEdge,
  getSliceMenu,
  getSliceMenuOverlayColor,
  getSliceMenuOverlayIsBlack,
  getSliceOverlayImage,
  getSlicePosition,
  getSliceTitleAndTag,
  getSliceTypography,
} from '../../selectors';
import Caption from './Caption';
import theme, { easeOutQuad, expandAbsolutely, makeResponsiveSettings } from '../../styles/theme';

const HeaderCaption = ({
  alignment, classes, edgeToEdge, overlayImage, position, sliceId, title, titleTag, topBiases,
  typography,
}) => (
  <div>
    <OverlayImage image={overlayImage} />
    <Caption
      alignment={alignment}
      carouselId={sliceId}
      className={classes.caption}
      edgeToEdge={edgeToEdge}
      isCurrent
      position={position}
      title={title}
      titleTag={titleTag}
      topBiases={topBiases}
      typography={typography}
    />
    <div className={classes.menuOverlay} />
  </div>
);

HeaderCaption.propTypes = {
  alignment: alignmentType,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  edgeToEdge: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in injectSheet()
  menuIsActive: PropTypes.bool.isRequired,
  overlayImage: responsiveImageType,
  position: alignmentType,
  sliceId: PropTypes.number.isRequired,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  topBiases: PropTypes.objectOf(PropTypes.number),
  typography: typographyType,
};

HeaderCaption.defaultProps = {
  alignment: undefined,
  overlayImage: undefined,
  position: undefined,
  title: undefined,
  titleTag: undefined,
  topBiases: undefined,
  typography: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  ...getSliceTitleAndTag(state, sliceId),
  alignment: getSliceAlignment(state, sliceId),
  edgeToEdge: getSliceIsEdgeToEdge(state, sliceId),
  menu: getSliceMenu(state, sliceId),
  menuIsActive: getSliceActiveMenuIndex(state, sliceId) >= 0,
  menuOverlayColor: getSliceMenuOverlayColor(state, sliceId),
  menuOverlayIsBlack: getSliceMenuOverlayIsBlack(state, sliceId),
  overlayImage: getSliceOverlayImage(state, sliceId),
  position: getSlicePosition(state, sliceId),
  typography: getSliceTypography(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    caption: {
      pointerEvents: 'none',
    },
    menuOverlay: {
      ...expandAbsolutely,
      transition: `background-color 0.6s ${easeOutQuad}`,
      pointerEvents: ({ menuIsActive }) => (menuIsActive ? 'auto' : 'none'),
      ...makeResponsiveSettings([
        'backgroundColor', 'menuOverlayColor', (menuOverlayColor, { menuIsActive }) => (
          menuIsActive ? menuOverlayColor : theme.colors.transparent
        ),
      ]),
    },
  }),
)(HeaderCaption);
